module.exports = __webpack_public_path__ + "img/holzdeck03.e5f05e6e.webp";